import { runMutation, runQuery } from '../graphQl'
import * as customListQuery from '../query/customList'

export const CreateCustomList = (data, name) => {
  return runMutation(customListQuery.CreateCustomListQuery(), { data, name }, 'tenant')
}

export const GetActiveCustomLists = () => {
  return runMutation(customListQuery.GetActiveCustomListsQuery(), {}, 'tenant')
}

export const GetPaginatedActiveCustomLists = (limit, offset, where, orderBy) => {
  return runMutation(customListQuery.GetPaginatedActiveCustomListsQuery(), { limit, offset, where, orderBy }, 'tenant')
}

export const GetCustomList = (id) => {
  return runMutation(customListQuery.GetCustomListQuery(), { id }, 'tenant')
}

export const GetPaginatedCustomList = (id, limit, offset, search) => {
  const conditions = {
    deleted: { _eq: false },
    parent_id: { _is_null: true }
  }
  if (search.length) {
    conditions._or = [
      { name: { _ilike: `%${search}%` } },
      { abbreviation: { _ilike: `%${search}%` } }
    ]
  }
  return runMutation(customListQuery.GetPaginatedCustomListQuery(), { id, limit, offset, conditions }, 'tenant')
}

export const GetCustomListChild = (id) => {
  return runMutation(customListQuery.GetCustomListChildQuery(), { id }, 'tenant')
}

export const GetPaginatedCustomListChild = (id, limit, offset, search) => {
  return runMutation(customListQuery.GetPaginatedCustomListChildQuery(), { id, limit, offset, search: search ? `%${search}%` : '%%' }, 'tenant')
}

export const getGivenCustomListsData = (ids) => { // expecting an array of customlist ids
  return runMutation(customListQuery.GetCustomListsQuery(), { ids }, 'tenant')
}

export const GetTaskStatus = () => {
  return runQuery(customListQuery.GetTaskStatusQuery(), {}, 'tenant')
}

export const getMaterialAttatchedCount = (id) => {
  return runQuery(customListQuery.getAttachedMaterialCountQuery(), { id }, 'tenant')
}

export const GetResourceGroupCount = (id) => {
  return runQuery(customListQuery.GetResourceGroupCountQuery(), { id }, 'tenant')
}

export const ResourceStateValueCount = (id) => {
  return runQuery(customListQuery.ResourceStateValueCountQuery(), { id }, 'tenant')
}

export const MaterialTypeCount = (id) => {
  return runQuery(customListQuery.MaterialTypeCountQuery(), { id }, 'tenant')
}

export const GetUnitOfMaterialCount = (id) => {
  return runQuery(customListQuery.GetUnitOfMaterialCountQuery(), { id }, 'tenant')
}

export const GetTaskInStatusCount = (id) => {
  return runQuery(customListQuery.getStatusAssociatedTaskCount(), { id }, 'tenant')
}

export const ResourceState = () => {
  return runQuery(customListQuery.ResourceStateQuery(), {}, 'tenant')
}

export const DeleteCustomList = (id) => {
  return runMutation(customListQuery.DeleteCustomListQuery(), { id }, 'tenant')
}

export const UpdateCustomList = (id, data) => {
  return runMutation(customListQuery.UpdateCustomListQuery(), { id, data }, 'tenant')
}

export const CreateCustomListValues = (data) => {
  return runMutation(customListQuery.CreateCustomListValuesQuery(), { data }, 'tenant')
}

export const UpdateCustomListValues = (id, data) => {
  return runMutation(customListQuery.UpdateCustomListValuesQuery(), { id, data }, 'tenant')
}
export const ChangeOrderCustomListValues = (valueId, newPos) => {
  return runMutation(customListQuery.ChangeOrderCustomListValuesQuery(), { valueId, newPos }, 'tenant')
}
export const DeleteCustomListValues = (id) => {
  return runMutation(customListQuery.DeleteCustomListValuesQuery(), { id }, 'tenant')
}
export const ChangeDefaultCustomValue = (oldId, newId) => {
  return runMutation(customListQuery.changeDefaultValueQuery(), { oldId, newId }, 'tenant')
}
export const UpdateUOMCustomValue = (oldId, newId) => {
  return runMutation(customListQuery.UpdateUnitOfMaterialQuery(), { oldId, newId }, 'tenant')
}
export const validateCustomList = (name) => {
  return runQuery(customListQuery.validateCustomListQuery(), { name }, 'tenant')
}

export const UpdateMaterialCustomListValue = (oldId, newId) => {
  return runMutation(customListQuery.materialCustomListUpdateQuery(), { oldId, newId }, 'tenant')
}
export const GetMaterialElement = () => {
  return runQuery(customListQuery.GetMaterialElementQuery(), {}, 'tenant')
}
export const CreateCustomListImport = (payload) => {
  const input = payload?.input || payload
  return runMutation(customListQuery.CreateCustomListImportQuery(), {
    has_header: input.has_header,
    mapping: input.mapping,
    custom_list_id: input.custom_list_id,
    blob_key: input.blob_key,
    parent_id: input.parent_id ?? null
  }, 'tenant')
}

export const CheckTopLevelCustomListValueByAbbreviation = (customListId, abbreviation) => {
  return runQuery(customListQuery.CheckTopLevelCustomListValueByAbbreviationQuery(), {
    custom_list_id: customListId,
    abbreviation
  }, 'tenant')
}

export const CheckChildTopLevelCustomListValueByAbbreviation = (customListId, parentId, abbreviation) => {
  return runQuery(customListQuery.CheckChildTopLevelCustomListValueByAbbreviationQuery(), {
    custom_list_id: customListId,
    parent_id: parentId,
    abbreviation
  }, 'tenant')
}

export const CheckTopLevelCustomListValueByName = (customListId, name) => {
  return runQuery(customListQuery.CheckTopLevelCustomListValueByNameQuery(), {
    custom_list_id: customListId,
    name
  }, 'tenant')
}

export const CheckChildTopLevelCustomListValueByName = (customListId, parentId, name) => {
  return runQuery(customListQuery.CheckChildTopLevelCustomListValueByNameQuery(), {
    custom_list_id: customListId,
    parent_id: parentId,
    name
  }, 'tenant')
}

export const CopyCustomListValues = (targetCustomListId, targetParentId, valueIds) => {
  return runMutation(customListQuery.CopyCustomListValuesQuery(), {
    targetCustomListId,
    targetParentId,
    valueIds
  }, 'tenant')
}
